<template>
  <div class="row">
    <div class="col-xs-12 col-md-12">
      <card :header-text="'Actas - Documentos'">
        <template v-slot:card-header>
          <router-link class="btn btn-action btn-small btn-success"
            :to="{ name: 'subir-documento' }"
          >
            <i class="fa fa-plus"></i>&nbsp;<span>Nuevo documento</span>
          </router-link>
        </template>
        <div class="table-responsive">
          <table class="table table-striped first-td-padding">
            <thead>
              <tr>
                <td>Fecha</td>
                <td>Descripción</td>
                <td>Archivo</td>
              </tr>
            </thead>
            <tbody>
              <tr  v-for="(documento, key) in documentos" :key="key">
                <td>{{ documento.fechaCreacion.toDate().toLocaleString() }}</td>
                <td>{{ documento.descripcion }}</td>
                <td v-if="documento.url"><a class="text-danger" target="blank" :href="documento.url">{{ documento.nombre }}</a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { obtenerDocumentosPorDni } from '../../api/inspiradores'
import storage from '../../api/storage'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      documentos: [],
      urlDocumentos: []
    }
  },
  computed: {
    ...mapState('user', [
      'token',
      'user'
    ]),
    storage () {
      return storage
    }
  },
  mounted () {
    this.obtenerDocumentos()
  },
  methods: {
    async obtenerDocumentos () {
      const dni = this.user.numeroIdentificacion

      const collections = await obtenerDocumentosPorDni(dni)
      collections.forEach(async doc => {
        const documento = doc.data()
        documento.key = doc.id
        documento.url = await this.storage.obtenerUrlDocumentoPorNombre(documento.nombre, dni)
        this.documentos.push(documento)
      })
    }
  }
}
</script>
<style lang="scss">
  .table thead tr{
    color: #007bff;
  }
  .error-icon{
    color: #e34a4a;
  }
  .success-icon {
    display: inline-block;
    color: #4ae387;
  }
  .table-sm th, .table-sm td{
    padding: .7rem;
  }
  .color-icon-label-table {
    td:first-child {
      width: 1rem;
    }
  }
  .btn-small {
    font-size: 12px;
  }
  .btn-action {
    margin-right: 10px;
    padding: 4px 8px;
    &:last-child {
      margin-right: 0;
    }
    @media screen and (max-width: 992px) {
      span {
        display: none;
      }
    }
  }
</style>
